import { ChangeDetectorRef, Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { TranslateFormatText } from '../../helpers/array.helpers';
import { StandardRequestBase } from '../../services/request-base';
import { DataCheck } from '../../workflow/workflow.dialog';
import { BaseListDetail, BaseListSettings, DeleteTexts, SaveTexts } from '../base.list.settings';

/**
 * Settings → Secrets: passwords, tokens and keys in one place, used from scripts by name
 * (Secrets.get, client.setSecretHeader, client.setSecretBasicAuth). The value is never sent to the
 * browser; an empty input keeps the stored one (SecretController).
 */
@Component({
    selector: 'secrets-settings',
    templateUrl: '../base.list.settings.html'
})
export class SecretsSettings extends BaseListSettings {

    constructor(private translate: TranslateService, private standardService: StandardRequestBase, protected cdRef: ChangeDetectorRef) {
        super(cdRef);
    }

    getContentType() {
        return SecretsDetail;
    }

    loadList(handler) {
        this.standardService.executeGet('api/settings/secrets', 'getsecrets').subscribe(result => {
            handler((result || []).map(entry => ({ Caption: entry.Caption, ID: entry.SID })));
        });
    }

    loadData(data) {
        this.standardService.executeGet('api/settings/secrets', 'getsecret', 'sid=' + data).subscribe(result => {
            if (result) {
                result.NewValue = '';
                result.ClearValue = false;
                this.setSelectedItem(result);
            }
        });
    }

    getNewItem() {
        return {
            Name: this.translate.instant('@@Neues Secret'),
            NewValue: '',
            ClearValue: false,
            HasValue: false
        };
    }

    getDeleteText(sel): DeleteTexts {
        const retVal = new DeleteTexts();
        retVal.Question = new TranslateFormatText('@@Sind Sie sicher, dass Sie das Secret \'{0}\' loeschen moechten?');
        retVal.Question.FormatParams.push(sel.Caption);
        retVal.Success = new TranslateFormatText('@@Secret \'{0}\' erfolgreich geloescht.');
        retVal.Success.FormatParams.push(sel.Caption);
        retVal.Title = new TranslateFormatText('@@Secret loeschen');
        return retVal;
    }

    getSaveSuccessText(sel): SaveTexts {
        const retVal = new SaveTexts();
        retVal.Text = new TranslateFormatText('@@Secret \'{0}\' erfolgreich gespeichert.');
        retVal.Text.FormatParams.push(sel.Caption);
        retVal.Title = new TranslateFormatText('@@Secret speichern');
        return retVal;
    }

    delete(data, handler) {
        this.standardService.executeDelete('api/settings/secrets', 'deletesecret', 'sid=' + data).subscribe((res) => {
            handler(res);
        });
    }

    saveInternal(item, handler) {
        this.standardService.executePost(item, 'api/settings/secrets', 'savesecret').subscribe(result => {
            if (result) {
                // The value stays on the server; the form forgets what was typed.
                if (item.NewValue) {
                    item.HasValue = true;
                }
                if (item.ClearValue) {
                    item.HasValue = false;
                }
                item.NewValue = '';
                item.ClearValue = false;
                handler(result, result, item.Name);
            }
        });
    }

    handleNew(item, result) {
        item.SID = result;
    }

    protected async checkCanSave(): Promise<DataCheck> {
        const retVal = new DataCheck();
        const sel = this.Component.SelectedItem;
        if (sel && (typeof sel.Name !== 'string' || sel.Name.trim() === '')) {
            retVal.IsCorrect = false;
            retVal.Error = this.translate.instant('@@Fehlender Name');
        }
        return retVal;
    }

    static GetSettingsEntry() {
        return {
            Caption: '@@Secrets',
            ID: 'secrets',
            Icon: 'key',
            Index: 61,
            Parent: 'settings',
            Security: {
                Name: 'evidanza.App.Shared.Security.PageSettingsRight',
                Value: 2
            },
            Content: SecretsSettings
        };
    }
}

@Component({
    selector: 'secrets-detail',
    templateUrl: './secrets.settings.html'
})
export class SecretsDetail extends BaseListDetail {
    ShowValue = false;

    clearValue() {
        this.SelectedItem.NewValue = '';
        this.SelectedItem.ClearValue = true;
        this.OnItemChanged();
    }
}
